<template>
    <v-form ref="form">
        <v-row>
            <v-col>
                <v-text-field
                    :label="$t('traffic_license_name')"
                    v-model="form.name"
                    :rules="[isRequired]"
                    outlined
                    hide-details="auto"
                    dense
                ></v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <DatePicker
                    :label="$t('start_date')"
                    v-model="form.start_at"
                    :rules="[isRequired]"
                    outlined
                    dense
                    hide-details="auto"
                    @change="onStartAtChange"
                />
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <DatePicker
                    :label="$t('end_date')"
                    v-model="form.end_at"
                    :rules="[isRequired]"
                    outlined
                    dense
                    hide-details="auto"
                />
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import DatePicker from './../common/DatePicker.vue';
import { isRequired, isNumeric } from './../../utils/validations';
import moment from 'moment';

export default {
    components: {
        DatePicker,
    },
    props: {
        value: Object
    },
    data() {
        return {
            form: {
                name: null,
                start_at: null,
                end_at: null
            }
        }
    },
    computed: {

    },
    watch: {
        form: {
            deep: true,
            handler(form) {
                this.$emit("input", {...form})
            }
        },
    },
    methods: {
        isRequired,
        isNumeric,
        onStartAtChange(val) {
            this.form = {
                ...this.form,
                end_at: moment(val).add(1, "year").format("YYYY-MM-DD")
            }
        }
    },
    created() {
        this.form = {...this.value}
    }
}
</script>

<style>

</style>